/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
const ReservationTab = {
  getTabMenus: (base, reservationId, isOwner) => {
    /* オーナーが予約情報を編集しないよう一時的な対応 */
    if (isOwner) {
      return [{ label: '予約詳細', url: `${base}/${reservationId}/detail` }]
    }

    return [
      { label: '詳細', url: `${base}/${reservationId}/detail` },
      { label: '請求書', url: `${base}/${reservationId}/invoices` },
      { label: 'API', url: `${base}/${reservationId}/api_message` },
      {
        label: '変更履歴',
        url: `${base}/${reservationId}/log`
      },
      {
        label: '自動アクション',
        url: `${base}/${reservationId}/auto_action_log`
      }
    ]
  }
}

export default ReservationTab
